import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';

function Products() {
  const page = "product";
  return (
    <div>
      {/* <Header /> */}
      <section className={`hero ${page}`}>
        <h1>Products</h1>
      </section>

      <section className="industory-section" id="industory">
        <div className="container">
          <div className="industory-grid">

            {/* Card 1 */}
            <span className="industory-card">
              <a href="">
                <div className="thumb">
                  <img src="assets/images/products/MD-BAR.png" alt="MD-BAR" />
                  {/*img src="../project/images/images/industry.jpg" alt="Feldspar"*/}
                </div>
                <div className="description">
                  A high-specific gravity material used primarily for weighting agent applications in water, oil and synthetic based fluids. 
                  MD-BAR can also be used as a bridging agent in wellbore strengthening applications. It is widely used in drilling, completion, 
                  workover fluids and cementing applications to control formation pressures and provide wellbore stability. It fulfills world 
                  cement control solutions..
                </div>
              </a>
              <div className="card-footer">
                <div className="title">MD-BAR</div>
                <a className="btn-inquire" href="/contactUs">INQUIRE</a>
              </div>        
              {/* <div className="title">MD-BAR</div> */}
            </span>
            


            {/* Card 2 */}
            <span className="industory-card">
              <a href="">
                <div className="thumb">
                  <img src="assets/images/products/MD-CAR.png" alt="MD-BAR" />
                  {/*img src="../project/images/images/industry.jpg" alt="Feldspar"*/}
                </div>
                <div className="description">
                  An acid-soluble, engineered product designed as a bridging agent for fluid loss control in water-based, oil-based and synthetic 
                  based drilling fluids. MD-CAR is compatible with most additives used in drilling fluid systems and is designed to minimize 
                  differential sticking and lost circulation problems.
                </div>
              </a>
              <div className="card-footer">
                <div className="title">MD-CAR</div>
                <a className="btn-inquire" href="/contactUs">INQUIRE</a>
              </div>
              {/* <div className="title">MD-CAR</div> */}
            </span>

            {/* Card 3 */}
            <span className="industory-card">
              <a href="">
                <div className="thumb">
                  <img src="assets/images/products/MD-BENT.png" alt="MD-BENT" />
                  {/*img src="../project/images/images/automotive.jpg" alt="Feldspar"*/}
                </div> 
                <div className="description">
                  A superior bentonite used for oil and water well drilling, foundry, civil engineering and environmental applications. MD-BENT is 
                  sodium-activated, natural, swelling bentonite exhibiting high yield, superior gel strength and excellent filtration control.
                </div>
              </a>
              <div className="card-footer">
                <div className="title">MD-BENT</div>
                <a className="btn-inquire" href="/contactUs">INQUIRE</a>
              </div>        
              {/* <div className="title">MD-BENT</div> */}
            </span>


            {/* Card 4 */}
            <span className="industory-card">
              <a href="">
                <div className="thumb">
                  <img src="assets/images/products/MD-OILGEL .png" alt="MD-OILGEL" />
                  {/*img src="../project/images/images/civil-engineering.jpg" alt="Feldspar"*/}
                </div>
                <div className="description">
                  A high-purity Organophilic Clay used for viscosifying oil-based drilling fluids. MD-OILGEL provides rapid yield, high efficiency 
                  and excellent suspension properties under demanding drilling conditions. It is designed for challenging drilling environments.
                </div>
              </a>
              <div className="card-footer">
                <div className="title">MD-OILGEL</div>
                <a className="btn-inquire" href="/contactUs">INQUIRE</a>
              </div>        
              {/* <div className="title">MD-OILGEL</div> */}
            </span>


            {/* Card 5 */}
            <span className="industory-card">
              <a href="">
                <div className="thumb">
                  <img src="assets/images/products/Seal-Lube .png" alt="SEAL-LUBE" />
                  {/*img src="../project/images/images/steel-industry.jpg" alt="Feldspar"*/}
                </div>         
                <div className="description">
                  A specially formulated, resilient, deformable lost-circulation control additive used to reduce severe to total fluid losses 
                  in both water and oil-based systems. SEAL-LUBE is compatible with all common drilling fluid systems and provides a flexible 
                  seal in fractures and highly permeable zones. It is also available in polypropylene/polyethylene (PP/PE) wells.
                </div>
              </a>  
              <div className="card-footer">
                <div className="title">SEAL-LUBE</div>
                <a className="btn-inquire" href="/contactUs">INQUIRE</a>
              </div>        
              {/* <div className="title">SEAL-LUBE</div> */}
            </span>        

            {/* Card 6 */}
            <span className="industory-card">
              <a href="">
                <div className="thumb">
                  <img src="assets/images/products/ECDGUARD.png" alt="ECDGUARD" />
                  {/*img src="../project/images/images/steel-industry.jpg" alt="Feldspar"*/}
                </div>         
                <div className="description">
                  A specialized spacer designed to maintain a cleaning environment for water, oil, and synthetic-based drilling fluids. 
                  ECDGUARD minimizes Equivalent Circulating Density (ECD) in narrow hydraulic windows, reduces surge/swab pressures and 
                  provides effective hole cleaning prior to cementing operations.
                </div>
              </a>
              <div className="card-footer">
                <div className="title">ECDGUARD</div>
                <a className="btn-inquire" href="/contactUs">INQUIRE</a>
              </div>        
              {/* <div className="title">ECDGUARD</div>         */}
            </span> 
          </div>
        </div>
      </section>

     {/* <Footer /> */}
    </div>
  )
}

export default Products